module.exports = __webpack_public_path__ + "static/media/ye.b5840a84.svg";